/**
 * Created by Jerker Nord on 2019-03-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../../ThorGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ThorGameAssets} from "../../ThorGameAssets";
import {TimelineLite, TweenLite} from "gsap";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {IconState, IIconView} from "../IIconView";

export class ThorReelWildIconView extends BaseView implements IIconView {
    get fsIconIsVisible():boolean {
        return this._fsIconIsVisible;
    }
    set fsIconIsVisible(value:boolean) {
        this._fsIconIsVisible = value;
        this.onResize(this._resizeData);
    }
    private _fsIconIsVisible:boolean = false;

    private static REEL_WILD_CONTAINER_LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(1104, 234);
    private static REEL_WILD_CONTAINER_PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(844, -91);
    public static thorReelWildIconView:ThorReelWildIconView;

    private _reelWildIconEnabled:PIXI.Sprite;
    private _reelWildIconDisabled:PIXI.Sprite;
    private _reelWildContainer:PIXI.Container;
    private _layer:ScalableLayer;
    private _state:IconState;
    private _enableReelWildIconTL:TimelineLite;
    private _disableReelWildIconTL:TimelineLite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.SCATTER_ANIMATION.name);
        this._layer.addChild(this);
        this._reelWildContainer = new PIXI.Container();
        this.addChild(this._reelWildContainer);
        this._state = IconState.disabled;
        ThorReelWildIconView.thorReelWildIconView = this;
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._reelWildContainer.position = ThorReelWildIconView.REEL_WILD_CONTAINER_PORTRAIT_POSITION;
            if (!this.fsIconIsVisible){
                this._reelWildContainer.position.x = ThorReelWildIconView.REEL_WILD_CONTAINER_PORTRAIT_POSITION.x + 130;
            }
            this._reelWildContainer.scale.set(1.2, 1.2);
        } else {
            this._reelWildContainer.position = ThorReelWildIconView.REEL_WILD_CONTAINER_LANDSCAPE_POSITION;
            this._reelWildContainer.scale.set(1, 1);
        }
    }

    protected initAnimations():void {
        this._reelWildIconDisabled = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_REEL_OF_WILDS_DISABLED)[0]);
        this._reelWildContainer.addChild(this._reelWildIconDisabled);

        this._reelWildIconEnabled = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_REEL_OF_WILDS_ENABLED)[0]);
        this._reelWildIconEnabled.alpha = 0;
        this._reelWildContainer.addChild(this._reelWildIconEnabled);
    }

    public abort():void{
        if(this._enableReelWildIconTL && this._enableReelWildIconTL.isActive()) {
            this._enableReelWildIconTL.pause();
            this._enableReelWildIconTL.kill();
        }
    }

    public enableReelWildIconTL(isFreeSpin:boolean):TimelineLite {
        if(this._enableReelWildIconTL && this._enableReelWildIconTL.isActive()) {
            this._enableReelWildIconTL.pause();
            this._enableReelWildIconTL.kill();
        }
        this._enableReelWildIconTL = new TimelineLite();
        this._enableReelWildIconTL.add(ThorGameModuleConfig.thorMjolnirtimeView.getIconSelectAnimation(2, isFreeSpin));
        return this._enableReelWildIconTL;
    }

    public disableReelWildIconTL(delay:number):TimelineLite {
        if(this._disableReelWildIconTL && this._disableReelWildIconTL.isActive()) {
            this._disableReelWildIconTL.pause();
            this._disableReelWildIconTL.kill();
        }
        this._disableReelWildIconTL = new TimelineLite({delay : delay});
        this._disableReelWildIconTL.add([
            new TweenLite(this._reelWildIconEnabled, 0.4, {alpha : 0}),
            new TweenLite(this._reelWildIconDisabled, 0.2, {alpha : 1})
        ]);
        this._disableReelWildIconTL.add(() => this.setState(IconState.disabled));
        return this._disableReelWildIconTL;
    }

    public getState():IconState {
        return this._state;
    }

    public setState(state:IconState):void {
        this._state = state;
        switch(state) {
            case IconState.disabled:
                this._reelWildIconDisabled.alpha = 1;
                this._reelWildIconEnabled.alpha = 0;
                break;
            case IconState.enabled:
                this._reelWildIconEnabled.alpha = 1;
                this._reelWildIconDisabled.alpha = 0;
                break;
            case IconState.activated:
                this._reelWildIconEnabled.alpha = 1;
                this._reelWildIconDisabled.alpha = 0;
                break;
            default:
                debugger;
                throw new Error("IconStates.setState(): Illegal icon state " + state);
        }
    }
}